<template>
  <a-layout class='index animated fadeIn'>
    <div class="s_bf" :bordered='false'>
      <a-table v-if='deliverData.award_info.length' :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns'
        :data-source='deliverData.award_info'>
        <template v-slot:good="{ record }">
          <a-card-meta>
            <template #avatar>
              <img class="table_img" :src="info.picdomain+(record.cover_image_url)" alt="">
            </template>
            <template #description>
              <p class="s_omit">{{record.gift_name}}</p>
            </template>
          </a-card-meta>
        </template>
      </a-table>
      <a-form class="m-t-20" ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol"  :wrapper-col="wrapperCol">
        <a-form-item ref="" label="收货地址" name="" style='margin-bottom: 15px;'>
          <p><span class="m-r-20">{{deliverData.receiv_name}}，{{deliverData.receiv_phone}}</span> {{deliverData.receiv_area}}</p>
        </a-form-item>
        <a-form-item ref="" label="买家备注" name="" style='margin-bottom: 15px;'>
          <p>{{deliverData.receiv_remarks || '-'}}</p>
        </a-form-item>
        <a-form-item label="发货方式" style='margin-bottom: 15px;'>快递配送</a-form-item>
        <a-form-item label="物流公司" name="express_channel">
          <a-select v-model:value="form.express_channel" :style="{width:'200px'}" placeholder="请选择物流公司">
            <a-select-option v-for='item in list' :key='item.id' :value="item.id">{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="运单号" name="express_code">
          <a-input v-model:value="form.express_code" placeholder='请输入运单号' />
        </a-form-item>
        <a-form-item label="备注" name="remarks">
          <a-textarea v-model:value="form.remarks" showCount :maxlength="200" placeholder="请输入备注" :rows="4" />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 4 }">
          <a-button type="primary" @click="onSubmit" :loading='loading'>确定</a-button>
        </a-form-item>
      </a-form>
    </div>
  </a-layout>
</template>
<script>
  import { ref, reactive, toRefs, inject,onMounted } from 'vue';
  import { getExpressList } from "@/api/order";
  import { setEntityDeliver} from "@/api/qrcodeActivitys";
  import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  import store from "@/store";

  // 初始化默认筛选项数值
  let defForm = {
    express_channel: undefined,
    express_code: '',
    remarks:''
  }
  export default {
    name: 'entityDeliver',
    components: {},
    props: {
      deliverData: {
        type: Object
      }
    },
    setup(props, { emit }) {
      let columns = [
        {
          title: "商品",
          key: "good",
          slots: { customRender: "good" },
        },
        {
          title: "数量",
          dataIndex: "gift_num",
          key: "gift_num",
        }
      ];
      const form = ref({ ...defForm });
      const state = reactive({
        info: store.state.user.info,
        list:[],
        deliverData:{},
        loading: false,
        labelCol: { span: 4 },
        wrapperCol: { span: 18 },
        rules: {
          express_channel: [
            { required: true, message: '请选择物流公司' },
          ],
          express_code: [
            { required: true, message: '请输入运单号' },
          ]
        }
      });
      const ruleForm = ref()
      const initData = async () => {
          let res = await getExpressList({keyword:'',limit:100,page:1}).then(res => res.data);
          if (iscode(res)) {
            state.list = res.data.data;
          } else {
            message.error(res.message);
          }
      };
      const onSubmit = () => {
        ruleForm.value.validate().then(async() => {
          state.loading = true
          let res=await setEntityDeliver({...form.value,id:state.deliverData.id}).then(res=>res.data).catch(error=>error)
          if (iscode(res)) {
            emit("submitdeliver", form.value);
            message.success(res.message);
          } else {
            message.error(res.message);
          }
          state.loading = false
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
        initData();
        state.deliverData = props.deliverData;
      });
      return {
        form,
        columns,
        ...toRefs(state),
        ruleForm,
        onSubmit
        
      }
    }
  }
</script>